import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import CalendarEventAppResource from './CalendarEventAppResource';
import CalendarEventAttendeeReminderAppResource from './CalendarEventAttendeeReminderAppResource';
import LuCalendarEventAttendeeStatusAppResource from './LuCalendarEventAttendeeStatusAppResource';
import WorkspaceOrganizationMemberAppResource from './WorkspaceOrganizationMemberAppResource';

export const RSVP_STATUS = {
    YES: 'yes',
    MAYBE: 'maybe',
    NO: 'no',
    UNKNOWN: null,
};

class CalendarEventAttendeeAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Calendar-Event-Attendee';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'calendar-event-attendees';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
            'created_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'workspaceOrganizationMemberUuid',
            'calendarEventUuid',
            'calendarEventAttendeeStatusUuid',
            'workspaceOrganizationMember',
            'calendarEvent',
            'reminders',
            'calendarEventAttendeeStatus',
            'workspaceMemberCreatorUuid',
            'workspaceMemberCreator',
            'rsvpStatus',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            workspaceOrganizationMember: WorkspaceOrganizationMemberAppResource,
            calendarEvent: CalendarEventAppResource,
            reminders: CalendarEventAttendeeReminderAppResource,
            calendarEventAttendeeStatus: LuCalendarEventAttendeeStatusAppResource,
            workspaceMemberCreator: WorkspaceOrganizationMemberAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            workspaceOrganizationMember: 'workspace_organization_member_uuid',
            calendarEvent: 'calendar_event_uuid',
            calendarEventAttendeeStatus: 'calendar_event_attendee_status_uuid',
            workspaceMemberCreator: 'workspace_member_creator_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            workspaceOrganizationMemberUuid: {
                type: 'string',
                presence: true,
            },
            calendarEventUuid: {
                type: 'string',
                presence: true,
            },
            calendarEventAttendeeStatusUuid: {
                type: 'string',
                presence: true,
            },
            workspaceMemberCreatorUuid: {
                type: 'string',
                /**
                 * @TODO require this field before Event RSVP Feature is merged to prod
                 */
                // presence: true,
            },
            rsvpStatus: {
                type: 'string',
            },
        };
    }

}

export default CalendarEventAttendeeAppResource;
